import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class TextInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            if (value == '') {
                value = null
            }
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }


    render() {
        let styleInfo = this.props.styleInfo

        return (
            <div className="w-100 h-100 flexc text-start"  >
                {/* <input ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}
                <input style={{ color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }} ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} onClick={() => this.selectHandler()} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" />

            </div>
        )
    }
}

export default TextInput;